import { render, staticRenderFns } from "./scenario.vue?vue&type=template&id=36efde7d&scoped=true&"
import script from "./scenario.vue?vue&type=script&lang=js&"
export * from "./scenario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36efde7d",
  null
  
)

export default component.exports